// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3RETo","paramInput":"JobSimulator_paramInput__PnC9H","input":"JobSimulator_input__1GKTm"};